import { render } from "./Bills.vue?vue&type=template&id=0708c198&scoped=true"
import script from "./Bills.vue?vue&type=script&lang=js"
export * from "./Bills.vue?vue&type=script&lang=js"

import "./Bills.vue?vue&type=style&index=0&id=0708c198&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0708c198"]])

export default __exports__